import { StateEvent } from '../constants/eventTypes';
import { ProductBuilderMachineState } from '../types';

type GetEventFromState = (state: ProductBuilderMachineState) => StateEvent;
type Cases = {
  [key in ProductBuilderMachineState]: StateEvent;
};

export const getEventFromState: GetEventFromState = state => {
  const cases: Cases = {
    bottomRailColour: { type: 'BOTTOM_RAIL_COLOUR' },
    bracketColour: { type: 'BRACKET_COLOUR' },
    bottomBarColour: { type: 'BOTTOM_BAR_COLOUR' },
    componentsColour: { type: 'COMPONENTS_COLOUR' },
    cellDesign: { type: 'CELL_DESIGN' },
    chainColour: { type: 'CHAIN_COLOUR' },
    chainPosition: { type: 'CHAIN_POSITION' },
    chainRelease: { type: 'CHAIN_RELEASE' },
    chainType: { type: 'CHAIN_TYPE' },
    colour: { type: 'COLOUR' },
    colourDay: { type: 'COLOUR_DAY' },
    colourNight: { type: 'COLOUR_NIGHT' },
    commonValance: { type: 'COMMON_VALANCE' },
    complete: { type: 'COMPLETE' },
    configuration: { type: 'CONFIGURATION' },
    cordPosition: { type: 'CORD_POSITION' },
    designerTape: { type: 'DESIGNER_TAPE' },
    dayColour: { type: 'DAY_COLOUR' },
    dayFabricPosition: { type: 'DAY_FABRIC_POSITION' },
    driveControl: { type: 'DRIVE_CONTROL' },
    extensionPole: { type: 'EXTENSION_POLE' },
    fitting: { type: 'FITTING' },
    holdDownBrackets: { type: 'HOLD_DOWN_BRACKETS' },
    idle: { type: 'IDLE' },
    liftPosition: { type: 'LIFT_POSITION' },
    lightGuards: { type: 'LIGHT_GUARDS' },
    transparency: { type: 'TRANSPARENCY' },
    pleatFinish: { type: 'PLEAT_FINISH' },
    lining: { type: 'LINING' },
    wand_option: { type: 'WAND_OPTION' },
    wand_colour: { type: 'WAND_COLOUR' },
    wand_colour_price: { type: 'WAND_COLOUR_PRICE' },
    wand_colour_variant_id: { type: 'WAND_COLOUR_VARIANT_ID' },
    track_colour_variant_id: { type: 'TRACK_COLOUR_VARIANT_ID' },
    track_colour_price: { type: 'TRACK_COLOUR_PRICE' },
    lining_colour_variant_id: { type: 'LINING_COLOUR_VARIANT_ID' },
    lining_colour_price: { type: 'LINING_COLOUR_PRICE' },
    liningColour: { type: 'LININGCOLOUR' },
    liningStyle: { type: 'LINING_STYLE' },
    materialType: { type: 'MATERIAL_TYPE' },
    materialTypeDay: { type: 'MATERIAL_TYPE_DAY' },
    materialTypeNight: { type: 'MATERIAL_TYPE_NIGHT' },
    measureInsurance: { type: 'MEASURE_INSURANCE' },
    measurements: { type: 'MEASUREMENTS' },
    mountingSurface: { type: 'MOUNTING_SURFACE' },
    pleatType: { type: 'PLEAT_TYPE' },
    powerSupply: { type: 'POWER_SUPPLY' },
    railColour: { type: 'RAIL_COLOUR' },
    remoteControl: { type: 'REMOTE_CONTROL' },
    rollDirection: { type: 'ROLL_DIRECTION' },
    roomName: { type: 'ROOM_NAME' },
    shipping: { type: 'SHIPPING' },
    slatSize: { type: 'SLAT_SIZE' },
    stackSide: { type: 'STACK_SIDE' },
    tiltControl: { type: 'TILT_CONTROL' },
    tiltPosition: { type: 'TILT_POSITION' },
    track: { type: 'TRACK' },
    trackRequire: { type: 'TRACK_REQUIRE' },
    trackColour: { type: 'TRACK_COLOUR' },
    pullRod: { type: 'PULL_ROD' },
    pullRodColour: { type: 'PULLROD_COLOUR' },
    wifiHub: { type: 'WIFI_HUB' },
    bladeSize: { type: 'BLADE_SIZE' },
    frameStyle: { type: 'FRAME_STYLE' },
    numberOfPanels: { type: 'NUMBER_OF_PANELS' },
    panelConfiguration: { type: 'PANEL_CONFIGURATION' },
    dynamicPrice: { type: 'DYNAMIC_PRICE' },
    operation: { type: 'OPERATION' },
    smartRelease: { type: 'SMART_RELEASE' },
    fascia: { type: 'FASCIA' },
    venetianValance: { type: 'VENETIAN_VALANCE' },
    totalPrice: { type: 'TOTAL_PRICE' },
    smartReleasePrice: { type: 'SMART_RELEASE_PRICE' },
    extensionPolePrice: { type: 'EXTENSION_POLE_PRICE' },
    lightGuardPrice: { type: 'LIGHT_GUARD_PRICE' },
    honeycombVerticalCentreOpeningSurcharge: {
      type: 'HONEYCOMB_VERTICAL_CENTRE_OPENING_SURCHARGE',
    },
    honeycombVerticalCentreOpeningSurchargePrice: {
      type: 'HONEYCOMB_VERTICAL_CENTRE_OPENING_SURCHARGE_PRICE',
    },
    venetianValancePrice: { type: 'VENETIAN_VALANCE_PRICE' },
    trackPrice: { type: 'TRACK_PRICE' },
    fasciaPrice: { type: 'FASCIA_PRICE' },
    measureInsurancePrice: { type: 'MEASURE_INSURANCE_PRICE' },
    stainlessSteelChainPrice: { type: 'STAINLESS_STEEL_CHAIN_PRICE' },
    stainlessSteelChain: { type: 'STAINLESS_STEEL_CHAIN' },
    ceilingMountPleatedCurtainRail: {
      type: 'CEILING_MOUNT_PLEATED_CURTAIN_RAIL',
    },
    faceMountPleatedCurtainRail: { type: 'FACE_MOUNT_PLEATED_CURTAIN_RAIL' },
    ceilingMountWaveFoldCurtainRail: {
      type: 'CEILING_MOUNT_WAVE_FOLD_CURTAIN_RAIL',
    },
    faceMountWaveFoldCurtainRail: {
      type: 'FACE_MOUNT_WAVE_FOLD_CURTAIN_RAIL',
    },
    ceilingMountPleatedCurtainDoubleRail: {
      type: 'CEILING_MOUNT_PLEATED_CURTAIN_DOUBLE_RAIL',
    },
    faceMountPleatedCurtainDoubleRail: {
      type: 'FACE_MOUNT_PLEATED_CURTAIN_DOUBLE_RAIL',
    },
    ceilingMountWaveFoldCurtainDoubleRail: {
      type: 'CEILING_MOUNT_WAVE_FOLD_CURTAIN_DOUBLE_RAIL',
    },
    faceMountWaveFoldCurtainDoubleRail: {
      type: 'FACE_MOUNT_WAVE_FOLD_CURTAIN_DOUBLE_RAIL',
    },
  };
  return state in cases ? cases[state] : cases.materialType;
};
